module.exports = "../dist/img/product-detail-1-26.779d.jpg";